import React, { useState, useCallback, useEffect } from 'react'
import { Box, Typography, Divider, Paper, Grid, Card, CardContent, CardActions, Button, Chip, TextField } from '@mui/material';
import Modal from 'components/Modal';
import { useSnackbar } from 'notistack';
import { LocalizationProvider, MobileDateRangePicker } from '@mui/lab';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import IssueDetails from './IssueDetails';
import { getIssuesByDate } from 'services/issues';
import { isValid } from 'date-fns';
import { getDBDateFormat } from 'services/commonServices';
import { getLibraryBookingDetails } from 'services/bookings';

const Complaints = () => {

  const [openModal, setOpenModal] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [complaints, setComplaints] = useState([]);
  const [complaintDetails, setComplaintDetails] = useState(null);
  const [searchText, setSearchText] = useState('');
  const currentDate = new Date();
  const [ filterDates, setFilterDates] = React.useState([new Date(currentDate.setMonth(currentDate.getMonth()-2)), new Date()]);

  function onDateAccepted(data) {
    const [fromDate,  toDate] = data;
    if(isValid(fromDate) && isValid(toDate)) {
      setSearchText('');
      setFilterDates(data);
      getAllComplaints(getDBDateFormat(fromDate), getDBDateFormat(toDate))
    }else{
      enqueueSnackbar(`Select ${fromDate === null ? 'From Date' : 'To Date'}`, {variant: 'error'});
    }
  }

  useEffect(() => {
    const [fromDate,  toDate] = filterDates;
    if(isValid(fromDate) && isValid(toDate)) {
      getAllComplaints(getDBDateFormat(fromDate), getDBDateFormat(toDate));
    }
  }, [filterDates])
  
  const onModalClose = useCallback(
    () => {
      setOpenModal(false);
    },
    [setOpenModal],
  )
  const onSuccess = () => {
    const [fromDate,  toDate] = filterDates;
    setOpenModal(false);
    getAllComplaints(getDBDateFormat(fromDate), getDBDateFormat(toDate))
  }

  function getAllComplaints(fromDate, toDate) {
    getIssuesByDate({fromDate, toDate}).then(({response, error}) => {
      if(response){
        setComplaints([...response]);
      } else {
        setComplaints([]);
        enqueueSnackbar((response?.message || error), {variant: 'error'});
      }
    });
  }


  const onCardClick = (e, issueId, bookingId, conversations, property, issueCreatedBy, title) => {
  
    getLibraryBookingDetails({bookingId }).then(({response, error}) => {
      if(response){
        setComplaintDetails({
          bookingDetails: response,
          conversations,
          property: property,
          title,
          issueId
        });
        setOpenModal(true);
      } else {
        setComplaintDetails({});
        setOpenModal(false);
        enqueueSnackbar((response?.message || error), {variant: 'error'});
      }
    });
  }

  const filterResults = complaint => (
    (complaint?.property?.city || '').toLowerCase().includes(searchText.toLowerCase())
    || (complaint?.property?.area || '').toLowerCase().includes(searchText.toLowerCase())
    || (complaint?.property?.name || '').toLowerCase().includes(searchText.toLowerCase())
  );

  return (
    <Paper sx={{ minWidth: 275, py: 2, px: 3, minHeight: "calc(100vh - 100px )" }}>
      <Typography component="h2" variant="h6" color="secondary"  gutterBottom sx={{mb: 1}}>
        Complaints
      </Typography>
      <Divider />
      <Box noValidate  sx={{ mt: 2 }} >
        <Grid container columnSpacing={4} rowSpacing={4} sx={{mt: 1 }}  justifyContent="flex-start" >
          <Grid container sx={{p:1, ml:4, bgcolor: "#f3f3f3"}}>
            <Typography variant="subtitle2" gutterBottom component="div">
              Filters
            </Typography>
            <Grid container item xs={12} sm={12} md={12} xl={12} lg={12} >
              <Grid item sx={{mt: 2}} xs={12} sm={12} md={12} xl={6} lg={6}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <MobileDateRangePicker
                    inputFormat="dd/MM/yyyy"
                    startText="From Date"
                    endText="To Date"
                    value={filterDates}
                    // clearable={true}
                    onChange={(newValue) => {
                      // setFilterDates(newValue);
                    }}
                    onAccept={(data) => onDateAccepted(data)}
                    renderInput={(startProps, endProps) => (
                      <React.Fragment>
                        <TextField {...startProps} size="small" onKeyDown={(e) => {e.preventDefault();return false}}/>
                        <Box sx={{ mx: 2 }}> to </Box>
                        <TextField {...endProps} size="small" onKeyDown={(e) => {e.preventDefault();return false}} />
                      </React.Fragment>
                    )}
                    />
                </LocalizationProvider>
              </Grid>
              <Grid item sx={{mt: 1}} xs={12} sm={12} md={12} xl={6} lg={6} textAlign="right" >
                <TextField  label="Search" variant="standard" onChange={(e) => setSearchText(e.target.value)} value={searchText} />
              </Grid>
            </Grid>
          </Grid>
          {complaints.filter(filterResults).map((complaint, index) =>(
            <Grid item xs={12} sm={6} md={6} xl={3} lg={4} key={index}>
              <Card sx={{ maxWidth: 345 }}>
                <CardContent sx={{backgroundColor: '#f8f8f8'}}>
                  <Typography  variant="subtitle2" component="div" noWrap>
                    {complaint.summary}
                  </Typography>
                  <Typography gutterBottom variant="body2" component="div" noWrap>
                    {complaint?.property?.name}, {complaint?.property?.area}
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    {complaint.createdOn}
                  </Typography>
                </CardContent>
                <CardActions sx={{justifyContent: 'space-between'}}>
                  <Chip size="small" label={complaint.resolved ? 'Closed' : 'Open'} color={complaint.resolved ? 'success' : 'warning'}/>
                  <Button size="small" color="info"  sx={{textTransform: 'none'}} onClick={(e) => onCardClick(e, complaint.issueId, complaint.bookingId, complaint.conversations, complaint.property, complaint.createdBy, complaint.summary)}>
                    Details
                  </Button>
                </CardActions>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
      <Modal maxWidth={"sm"} open={openModal} onModalClose={onModalClose} title={complaintDetails?.title}>
        <IssueDetails  complaintDetails={complaintDetails} onSuccess={onSuccess} />
      </Modal>
    </Paper>
  );
}
 
export default Complaints;
